import styles from "./Designer.module.css";

const DesignerVariantStepSection = ({
  activeVariantName = "Sin variante seleccionada",
  variantOptions = [],
  switchingVariant = false,
  onContinue,
  onOpenCatalog,
}) => {
  const hasVariants = Array.isArray(variantOptions) && variantOptions.length > 0;

  return (
    <section className={styles.sectionCard}>
      <div className={styles.variantStepHero}>
        <p className={styles.variantStepSubtitle}>
          Estás diseñando <strong>{activeVariantName}</strong>. Si te copa, seguimos. Si no,
          podés cambiarlo ahora y arrancar con el modelo que más te guste.
        </p>
      </div>

      <div className={styles.variantStepCurrentCard}>
        <div className={styles.variantStepCurrentLabel}>Modelo actual</div>
        <div className={styles.variantStepCurrentName}>{activeVariantName}</div>
      </div>

      <div className={styles.variantStepActions}>
        <button type="button" className={`${styles.btn} ${styles.variantStepPrimary}`} onClick={onContinue}>
          Seguir con este modelo
        </button>
        {hasVariants ? (
          <button
            type="button"
            className={`${styles.btn} ${styles.variantStepSecondary}`}
            onClick={onOpenCatalog}
            disabled={switchingVariant}
          >
            {switchingVariant ? "Cambiando..." : "Cambiar modelo"}
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default DesignerVariantStepSection;
